import { Suspense } from 'react';
import { Outlet, Route, Routes } from 'react-router-dom';

import { ArtistDetailsPage } from '~/modules/artist-roster/components/ArtistDetails/ArtistDetailsPage';
import { RosterPage } from '~/modules/artist-roster/components/Roster/RosterPage';
import { TrackDetailsPage } from '~/modules/artist-roster/components/TrackDetails/TrackDetailsPage';

/**
 * Top-level router combining module-level routers
 */
const Router = () => {
  return (
    <Suspense>
      <Routes>
        <Route element={<Outlet />}>
          <Route path="*" element={<RosterPage />} />
          <Route path=":partyId" element={<ArtistDetailsPage />} />
          {/* Track name to be replaced with track family ID once API is finished */}
          <Route path=":partyId/:familyId" element={<TrackDetailsPage />} />
        </Route>
      </Routes>
    </Suspense>
  );
};

Router.displayName = 'RosterRouter';

export { Router };
